//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("cisRequest", CisRequestFactory);

    CisRequestFactory.$inject = ["apiClientFactory"];
    function CisRequestFactory(apiClientFactory) {

        const routePrefix = "api/Cis/Request/";

        return {
            AcceptRequest: apiClientFactory.patch(routePrefix + "Accept/"),
            ApproveStop: apiClientFactory.delete(routePrefix + "Stop/Approve/"),
            DenyStop: apiClientFactory.patch(routePrefix + "Stop/Deny/"),
            DownloadCertificate: apiClientFactory.getFile(routePrefix + "DownloadCertificate/"),
            Get: apiClientFactory.get(routePrefix),
            GetNew: apiClientFactory.get(routePrefix + "New/"),
            RecallRequest: apiClientFactory.patch(routePrefix + "Recall/"),
            RejectRequest: apiClientFactory.patch(routePrefix + "Reject/"),
            ReopenScreenings: apiClientFactory.patch(routePrefix + "ReopenScreenings/"),
            Save: apiClientFactory.put(routePrefix + "Save/"),
            SaveRemark: apiClientFactory.put(routePrefix + "SaveRemark/"),
            Search: apiClientFactory.post(routePrefix + "Search/"),
            StopRequest: apiClientFactory.patch(routePrefix + "Stop/"),
            Submit: apiClientFactory.patch(routePrefix + "Submit/"),
            SubmitCisTypeInfo: apiClientFactory.put(routePrefix + "SubmitCisTypeInfo/"),
        };
    }
})();
